module.exports = __webpack_public_path__ + "img/nginx.be3f82db.png";